<div class="flex flex-col gap-2 mb-2">
    <div class="text-base opacity-70 font-bold">{{ user }}</div>
    <div class="border rounded-md px-5 py-3">
        <div class="text-base italic font-light my-1" [innerHTML]="avis"></div>
        <div class="flex items-center justify-between mt-2">
            <span class="text-xs italic font-light">{{ createdAt }}</span>
            <button *ngIf="alfrescoId" pButton type="button" class="p-button-text p-button-sm" icon="pi pi-download"
                [label]="'common.download' | translate" (click)="onDownload()">
            </button>
        </div>
    </div>
</div>